import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import useUserCash from 'hooks/requests/portfolio/useUserCash';
import { HTMLAttributes } from 'react';
import Skeleton from 'react-loading-skeleton';
import { parseMoney } from 'utils/money_utils';
import classes from './index.module.scss';

type Props = HTMLAttributes<HTMLDivElement>;

const TotalCashTitle = ({ className }: Props) => {
  const { usableCash, loading } = useUserCash();

  return (
    <Typography className={classNames(classes.totalCash, className)}>
      {!loading ? (
        parseMoney(usableCash, { withCentsDisplay: true })
      ) : (
        <Skeleton
          width={140}
          height={30}
        />
      )}
    </Typography>
  );
};

export default TotalCashTitle;
